export default __webpack_public_path__ + "static/media/monitor-children.0b540f57.png";